import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';

import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private sessionService: SessionService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let audit_company_id = ''; // null -> error

    // Check request method => 'get' != 'GET'
    // console.log(request.method);
    // console.log(this.sessionService.currentUser());
    // console.log('sudo?: ', this.sessionService.currentUser().sd);
    // request.method !== 'get' &&
    // this.sessionService.currentUser() &&
    // this.sessionService.getSelectedAccountCompany()

    if (request && this.sessionService.isLoggedIn()) {
      const token = this.sessionService.getCurrentUser().token;

      // If we have a token, we set it to the header http
      if (token) {
        if (!this.sessionService.currentUser().sd) {
          // isLoggedIn to prevent not logged users
          audit_company_id = this.sessionService.getSelectedAccountCompany().id;
        }

        request = request.clone({
          setHeaders: {
            authorization: `Bearer ${token}`,
            audit_company_id: audit_company_id,
          },
        });
      }
    }

    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          // 'get
          // console.log(request.method);
          // console.log(evt.body);
          // request.method === 'GET' &&

          if (this.sessionService.isLoggedIn() && evt.body && evt.body.user_info) {
            let currentUser = this.sessionService.getCurrentUser();
            currentUser.user_info = evt.body.user_info;

            // Updates cu
            this.sessionService.setCurrentUser('cu', currentUser);

            if (this.sessionService.currentUser() && !this.sessionService.currentUser().sd) {
              const company = currentUser.user_info.companies.find(
                (company) => company.id === this.sessionService.getSelectedAccountCompany().id
              );

              this.sessionService.setSelectedAccountCompany(company);
            }
          }
        }
      }),
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            // redirect user to the logout page
          }
        }

        return throwError(() => err);
      })
    );

    // return next.handle(request).pipe(
    //   catchError((err) => {
    //     if (err instanceof HttpErrorResponse) {
    //       if (err.status === 401) {
    //         // redirect user to the logout page
    //       }
    //     }

    //     return throwError(() => err);
    //   })
    // );
  }
}

// if (
//   request &&
//   request.method !== 'GET' &&
//   this.sessionService.isLoggedIn() &&
//   this.sessionService.getSelectedAccountCompany()
// ) {
//   // isLoggedIn to prevent not logged users
//   audit_company_id = this.sessionService.getSelectedAccountCompany().id;
// }

// if (request && (request.method === 'PUT' || request.method === 'POST')) {
//   console.log('request method', request.method);
// }
